import * as ProSolidSvgIcons from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { Helmet } from 'react-helmet-async'
import Argus from 'src/assets/icons/customIcons/Argus'
import RefreshSvg from 'src/assets/icons/customIcons/Refresh.svg'
import { useTranslatable } from 'src/hooks/locale/utils'
import { Button } from 'src/tailwind/components/Button'

export default function MaintenanceModePage(): React.ReactElement | null {
  const t = useTranslatable()

  return (
    <>
      <Helmet title={t('system:technical_works_are_underway')} />
      <div className="flex h-screen w-full flex-col items-center justify-center px-4">
        <div className="mb-6 flex flex-col items-center">
          <h1 className="text-center text-headline font-semibold !text-primaryRed xxs:text-[20px] xs:text-[20px]">
            {t('system:argus')}
          </h1>
          <Argus className="my-2 w-16" />
        </div>
        <div className="w-full max-w-xl rounded-lg bg-card px-6 py-8 shadow-md">
          <div className="flex flex-col items-center text-center">
            <FontAwesomeIcon icon={ProSolidSvgIcons.faConstruction} size="3x" className="text-lightSecondaryWarning" />
            <h1 className="mb-2 text-2xl font-bold">{t('system:technical_works_are_underway')}</h1>
            <p className="mb-4 text-base text-gray-700">{t('system:technical_works_are_underway_description')}</p>

            <Button
              variant="blue"
              className="flex items-center px-4 py-2"
              title={t('group:groups_refresh')}
              onClick={() => window.location.reload()}
            >
              <img src={RefreshSvg} alt="refresh" className="size-4" />
              <span className="ml-2">{t('system:refresh_page')}</span>
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}
